// Polyfill for React 17 compatibility with libraries that require React 18
// This adds useSyncExternalStore to React if it doesn't exist
// Note: This is a runtime polyfill. For build-time replacement (ui-library),
// see react-with-useSyncExternalStore.ts which is used via webpack NormalModuleReplacementPlugin
import * as React from 'react';

// Type assertion needed because use-sync-external-store doesn't have built-in types
// eslint-disable-next-line @typescript-eslint/no-require-imports
const useSyncExternalStoreModule = require('use-sync-external-store/shim') as {
  useSyncExternalStore: <T>(
    subscribe: (onStoreChange: () => void) => () => void,
    getSnapshot: () => T,
    getServerSnapshot?: () => T
  ) => T;
};

const { useSyncExternalStore } = useSyncExternalStoreModule;

// Add useSyncExternalStore to React if it doesn't exist
if (!('useSyncExternalStore' in React)) {
  (React as any).useSyncExternalStore = useSyncExternalStore;
}

// Re-export for convenience if needed elsewhere
export { useSyncExternalStore };

